import React, {Component} from 'react';
import Select from"../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import {UncontrolledTooltip} from 'reactstrap';
import {validateField} from "../../../common/validation";
import {deepCopyObject} from "../../../helper/helper";

class TaxRepresentativeParty extends Component {
	constructor(props) {
		super(props);
		this.state = {error: {}, taxRepresentativeParty: null};
		this.onChange = this.onChange.bind(this);
		this.validateField = this.validateField.bind(this);
		this.getSubdivisionsForCity = this.getSubdivisionsForCity.bind(this);
		this.checkValue = this.checkValue.bind(this);
	}

	componentWillMount() {
		this.setState({taxRepresentativeParty: this.props.taxRepresentativeParty || {}});
	}

	onChange(e) {
		let taxRepresentativeParty = deepCopyObject(this.state.taxRepresentativeParty);
		taxRepresentativeParty[e.target.name] = e.target.value;
		if (e.target.name === "trpCity")
			taxRepresentativeParty["trpCitySubdivision"] = null;
		this.setState({taxRepresentativeParty});
		this.props.listener(taxRepresentativeParty);
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
		this.props.errorListener(error);
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.error !== nextProps.error) {
			this.setState({error: nextProps.error});
		}

		if (nextProps.manual) {
			this.setState({taxRepresentativeParty: nextProps.taxRepresentativeParty, error: {}});
			this.props.isManual(false);
			this.props.errorListener({});
		}
	}

	getSubdivisionsForCity(city) {
		if (!city) {
			return [];
		}

		return this.props.cities.find(obj => obj.cityName === city).subdivisions.map(subdiv => ({
			value: subdiv.name,
			label: subdiv.name
		}))
	}

	checkValue(key){
		return ((this.state.taxRepresentativeParty && this.state.taxRepresentativeParty[key]) ? this.state.taxRepresentativeParty[key] :  "");
	}

	render() {

		return (
			<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>VKN* </label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("trpIdentifier")}>
							<input className="form-control"
								   type="text"
								   data-vdata="vkn"
								   data-vlength="10,10"
								   maxLength="10"
								   id="trpIdentifier"
								   name="trpIdentifier"
								   onBlur={this.validateField}
								   onChange={this.onChange}
								   value={this.checkValue("trpIdentifier")}/>
							{this.validateMessage("trpIdentifier") !== "" &&
							<UncontrolledTooltip placement="right" target={"trpIdentifier"} delay={0}>
								{this.validateMessage("trpIdentifier")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Unvan *</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("trpFormattedName")}>
							<input className="form-control"
								   type="text"
								   data-vlength="1,255"
								   id="trpFormattedName"
								   name="trpFormattedName"
								   onBlur={this.validateField}
								   onChange={this.onChange}
								   value={this.checkValue("trpFormattedName")}/>
							{this.validateMessage("trpFormattedName") !== "" &&
							<UncontrolledTooltip placement="right" target={"trpFormattedName"} delay={0}>
								{this.validateMessage("trpFormattedName")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Posta Kutusu Etiketi *</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("trpAlias")}>
							<input className="form-control"
								   type="text"
								   data-vdata="required"
								   data-vlength="1,255"
								   id="trpAlias"
								   name="trpAlias"
								   onBlur={this.validateField}
								   onChange={this.onChange}
								   value={this.checkValue("trpAlias")}/>
							{this.validateMessage("trpAlias") !== "" &&
							<UncontrolledTooltip placement="right" target={"trpAlias"} delay={0}>
								{this.validateMessage("trpAlias")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Ülke *</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("trpCountry")}>
							<input className="form-control"
								   type="text"
								   data-vlength="1,255"
								   id="trpCountry"
								   name="trpCountry"
								   disabled
								   onBlur={this.validateField}
								   onChange={this.onChange}
								   value={this.checkValue("trpCountry") || this.onChange({target:{name:"trpCountry",value:"Türkiye"}})}/>
							{this.validateMessage("trpCountry") !== "" &&
							<UncontrolledTooltip placement="right" target={"trpCountry"} delay={0}>
								{this.validateMessage("trpCountry")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Şehir</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group " + this.validateClass('trpCity')}>
							<Select
								id="trpCity"
								value={this.checkValue("trpCity")}
								clearable={false}
								noResultsText="Sonuç yok"
								clearValueText="Temizle"
								placeholder="Seçiniz..."
								onChange={(e) => e && this.onChange({target: {name: "trpCity", value: e.value}})}
								options={this.props.cities.map(city => ({
									value: city.cityName,
									label: city.cityName
								}))}
							/>
							{this.validateMessage('trpCity') !== "" &&
							<UncontrolledTooltip placement="right" target="trpCity" delay={0}>
								{this.validateMessage("trpCity")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>İlçe</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group " + this.validateClass('trpCitySubdivision')}>
							<Select
								id="trpCitySubdivision"
								value={this.checkValue("trpCitySubdivision")}
								clearable={false}
								noResultsText="Sonuç yok"
								clearValueText="Temizle"
								placeholder="Seçiniz..."
								onChange={(e) => e && this.onChange({target: {name: "trpCitySubdivision", value: e.value}})}
								options={this.getSubdivisionsForCity(this.checkValue("trpCity"))}
							/>
							{this.validateMessage('trpCitySubdivision') !== "" &&
							<UncontrolledTooltip placement="right" target="trpCitySubdivision" delay={0}>
								{this.validateMessage("trpCitySubdivision")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default TaxRepresentativeParty;